import { useState, useEffect } from 'react'
import { enqueueSnackbar } from 'notistack'
import { useAssignedDigitalTrays } from 'views/DigitalTrayMapping/AssignedDigitalTrays/AssignedDigitalTrays.context'
import { useSPD } from 'views/SPDLayout/SPD/SPD.context'
import { UsageCustomImplantModalProps } from './UsageCustomImplantModel.types'

const useUsageCustomImplantModalLogic = ({
  implant,
  onClose,
}: UsageCustomImplantModalProps) => {
  const { usageCustomImplants, setUsageCustomImplants } =
    useAssignedDigitalTrays()
  const { customImplants, setCustomImplants } = useSPD()

  const [usageCount, setUsageCount] = useState<number>(1)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isWasted, setIsWasted] = useState<boolean>(false)

  // Reset count and wasted state when modal opens with new implant
  useEffect(() => {
    if (implant) {
      setUsageCount(1)
      setIsWasted(false)
    }
  }, [implant])

  if (!implant) return null

  const maxCount = implant.count
  const isSingleImplant = maxCount === 1

  const handleConfirm = () => {
    setIsLoading(true)
    // Simulate a brief loading state
    setTimeout(() => {
      // Add the specified number of implants to usage
      const newUsageImplants = Array(usageCount).fill({
        deviceId: implant.deviceId,
        deviceDescription: implant.deviceDescription,
        wasted: isWasted,
      })

      // Update usage custom implants
      setUsageCustomImplants([...usageCustomImplants, ...newUsageImplants])

      // Update SPD context by removing the used implants
      const deviceId = implant.deviceId
      let remainingToRemove = usageCount
      const updatedImplants = customImplants.filter((implant) => {
        if (implant.deviceId === deviceId && remainingToRemove > 0) {
          remainingToRemove--
          return false
        }
        return true
      })
      setCustomImplants(updatedImplants)

      setIsLoading(false)
      enqueueSnackbar('Implant usage recorded successfully', {
        variant: 'success',
      })
      onClose()
    }, 300)
  }

  return {
    isSingleImplant,
    isWasted,
    usageCount,
    maxCount,
    handleConfirm,
    isLoading,
    setIsWasted,
    setUsageCount,
  }
}

export default useUsageCustomImplantModalLogic
